class Sticky {

    /**
     * @since 4.0.0
     * @method constructor
     */
    constructor() {
        // Declare and initialize
        this.event        = 'scroll.sticky-onscroll resize.sticky-onscroll';
        this.sticker      = 'is-sticky';
        this.sticking     = 'is-sticking';
        this.selector     = '[data-toggle="sticky-onscroll"]';
        this.wrapperClass = 'sticky-wrapper';
        this.wrap         = false;

        // Run re-initialization if the screen gets resized
        $(window).resize(() => {

            // This is the re-initialization we were talking about
            this.init();

        });

        // Run initialization after a delay
        setTimeout(() => this.init(), 250);
    }

    /**
     * Initialize the class.
     *
     * @method init
     * @since 4.0.0
     * @returns void
     */
    init() {

        'use strict';

        // Declare and initialize
        var self = this;

        // Find all data-toggle="sticky-onscroll" elements
        $(this.selector).each((i, ele) => {

            // Declare and initialize
            var sticky  = $(ele);
            var wrapper = null;

            // Run the sticky sibling offset
            this.offsetSibling(sticky);

            // Only run the offset if the screen is too small
            if ($(window).width() < 769) return;

            // Male a wrapper if we need one
            if (this.wrap)
                wrapper = $('<div>').addClass(this.wrapperClass);

            // Inject our placeholder right next to the sticky
            if (this.wrap) sticky.before(wrapper);

            // Make our sticky sticky
            sticky.addClass('sticky');

            // Scroll & resize events
            $(window).on(this.event, (e) => {
                self.toggle(sticky, wrapper, $(e.currentTarget));
            });

            // On page load
            this.toggle(sticky, wrapper, $(window));

        });

    }

    /**
     * Retrieve the height of the siblings.
     *
     * @since 4.78.5
     * @method getSiblingHeightOffset
     * @param object sticky is the sticky nav in question
     * @return int The height of any siblings
     */
    getSiblingHeightOffset(sticky) {

        // Declare and initialize
        var offset        = 0;
        var olderSiblings = sticky.prevAll(':visible:not(.screen-reader-text)');

        // If there is no older sibling, bail out
        if (!olderSiblings.length)
            return offset;

        // Iterate through the siblings
        olderSiblings.each((i, e) => {

            // Get the sibling's identifier
            var olderSibling = $(e);

            // Compound our total height
            offset += olderSibling.outerHeight();

        });

        // Ok, there we go
        return offset;
    }

    /**
     * Offset the sticky header if there is an older sibling.
     *
     * @since 4.30.4
     * @method offsetSibling
     * @param object sticky is the sticky nav in question
     * @return void
     */
    offsetSibling(sticky) {
        // Declare and initialize
        var olderSiblings = sticky.prevAll(':visible:not(.screen-reader-text)');

        // If there is no older sibling, bail out
        if (!olderSiblings.length) {

            // Revert to normal
            let style = '<style>.sticky:not(.is-sticky){' +
                'margin-top: 0;' +
                '</style>';

            // Create the style
            $(style).appendTo('head');

            // Get out of here
            return;

        }

        // Declare and initialize
        var offset = this.getSiblingHeightOffset(sticky);
        var speed  = 500;

        // Set our single selector class
        sticky.addClass('once');

        // Close our out style
        let style = '<style>.sticky:not(.is-sticky){' +
            'margin-top: ' + offset + 'px;' +
            '</style>';

        // Create the style
        $(style).appendTo('head');

        // Remove our once class
        window.setTimeout(function () {

            // Only run the animation once
            sticky.removeClass('once');

            // Iterate through the siblings
            olderSiblings.each(function (i, e) {

                // Fade in the older sibling
                $(e).find('> *').animate({opacity: 1});

            });

        }, speed);
    }

    /**
     * Toggle the sticky situation.
     *
     * @method toggle
     * @since 4.0.0
     * @param object sticky is the sticky object
     * @param object wrapper is the placeholder wrapper
     * @param object element is that which is referenced in scroll
     * @returns void
     */
    toggle(sticky = null, wrapper = null, element = null) {

        // Declare and initialize
        var height = sticky.outerHeight();
        var top    = $('body').offset().top;

        // Get the top declaration if we are using a wrapper
        if (this.wrap)
            top = wrapper.offset().top

        // Emit an event
        sticky.trigger('stickToggleStart');

        // Toggle the stickiness
        if (element.scrollTop() > top) {

            // Adjust our placeholder height
            if (this.wrap) wrapper.height(height);

            // Add our sticker class
            sticky.addClass(this.sticker);

            // Set our flood class
            sticky.addClass(this.sticking);

            // Remove our flood class
            setTimeout(() => {
                sticky.removeClass(this.sticking);
            }, 3000);

            // Emit an event
            sticky.trigger('stickToggleOn');

        } else {

            // Unstick our stickered sticky
            sticky.removeClass(this.sticker);

            // Remove our flood class
            sticky.removeClass(this.sticking);

            // Collapse our placeholder height
            if (this.wrap) wrapper.height('auto');

            // Emit an event
            sticky.trigger('stickToggleOff');
        }

    }
}

export default Sticky;